import React, { Component, PropTypes } from 'react';


class SnackbarMessage extends Component {
  state = {
    visible: true
  };

  setTimer = () => {
    if(this._timer != null) {
      clearTimeout(this._timer);
    }

    this._timer = setTimeout(() => {
      this.setState({visible: false});
      this._timer = null;
    }, 3000);

  };

  componentWillReceiveProps(nextProps) {
    if(nextProps.message.content != this.props.message.content) {
      this.setTimer();
      this.setState({ visible: true });
    }
  }

  componentDidMount() {
    this.setTimer();
  }

  render() {
    let { message } = this.props;
    let cssClasses = `animated flash snackbar-message snackbar-${message.type}`;

    if(this.state.visible) {
      return <div className={cssClasses}>
        {message.content}
      </div>;
    }
    else {
      return <span />;
    }
  }
}

export default class Snackbar extends Component {
  render() {
    let { messages } = this.props.snackbar;
    let messageList = [];
    messageList = messages.map(message => {
      return <SnackbarMessage delay="2000" message={message} />;
    });
    return <div className="snackbar">{messageList}</div>;
  }
}



// WEBPACK FOOTER //
// ./src/components/Snackbar.jsx